import { Text, Box } from "theme-ui";
import { useSelector } from "react-redux";

import * as styles from "./ImageToolTip.styles";
import { Svg } from "components";
import { selectUserChoices } from "store/app";
import { makeUrl } from "store/app/selectProductImagesForAngle";

export default function ImageToolTip({
  labelImage,
  image,
  children,
  imageWidth,
  imageHeight,
  backgroundColor,
  dangerouslySetLabel,
}) {
  const userChoices = useSelector(selectUserChoices);

  const newUrl = makeUrl({
    url: image,
    allFields: {},
    userChoices,
    imageURLValueToUse: "imageURLValueForTooltips",
  });

  return (
    <Box sx={styles.imageToolTip({ imageWidth })}>
      <Box
        sx={styles.image({
          image: newUrl,
          imageWidth,
          imageHeight,
          backgroundColor,
        })}
      />

      {dangerouslySetLabel ? (
        <Text
          sx={styles.text({ hasChildren: true })}
          variant="copy3Light"
          dangerouslySetInnerHTML={{ __html: dangerouslySetLabel }}
        >
          {labelImage && (
            <Box sx={styles.labelImageContainer}>
              <Svg
                src={labelImage.url}
                alt={""}
                sx={styles.labelImageSvg({ color: labelImage.color })}
              />
            </Box>
          )}
        </Text>
      ) : (
        <Text
          sx={styles.text({ hasChildren: Boolean(children) })}
          variant="copy3Light"
        >
          {labelImage && (
            <Box sx={styles.labelImageContainer}>
              <Svg
                src={labelImage.url}
                alt={""}
                sx={styles.labelImageSvg({ color: labelImage.color })}
              />
            </Box>
          )}
          {children}
        </Text>
      )}
    </Box>
  );
}
